import { KJUR } from 'jsrsasign';

import { createRouter, createWebHistory } from 'vue-router'

const routes = [
  {
    path: '/',
    name: 'home',
    component: () => import('../views/HomeView.vue'),
  },
  {
    path: '/admin/login',
    name: 'AdminLogin',
    component: () => import('../views/admin/LoginView.vue'),
  },
  {
    path: '/admin/import',
    name: 'AdminImport',
    component: () => import('../views/admin/ImportView.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/admin/tickets/list',
    name: 'TicketList',
    component: () => import('../views/admin/TicketListView.vue'),
    props: true,
    meta: { requiresAuth: true }
  },
  {
    path: '/ticket/:uuid',
    name: 'TicketDetail',
    component: () => import('../views/public/TicketDetailView.vue'),
    props: true,
  },
]

const router = createRouter({
  history: createWebHistory(process.env.BASE_URL),
  routes
})

// ページが遷移する前に実行される
router.beforeEach((to, from, next) => {
  const token = localStorage.getItem('token')
  // console.log(token)

  if (to.matched.some(record => record.meta.requiresAuth)) {
    if (!token) {
      // JWTトークンがない場合はログインページにリダイレクト
      next({ name: 'AdminLogin' })
    } else {
      // const [header, payload, signature] = token.split('.');
      // const decodedHeader = KJUR.jws.JWS.readSafeJSONString(b64utoutf8(header));
      // const decodedPayload = KJUR.jws.JWS.readSafeJSONString(b64utoutf8(payload));
      const isValid = KJUR.jws.JWS.verify(token, 'my_secret_key', {alg: ['HS256']});

      // const h = header
      // const s = signature
      // const p = payload
      // console.log(header)
      // console.log(payload)
      // console.log(signature)
      // console.log(decodedPayload)
      // console.log(isValid)

      if (isValid) {
        // console.log(decodedPayload); // JWT が正当であれば、デコードされたペイロードが表示される
        next()
      } else {
        console.error('JWT が無効です');
        next({ name: 'AdminLogin' })
      }
    }
  } else {
    // 認証が不要なページの場合はそのまま遷移
    next()
  }
})

export default router
